export default __webpack_public_path__ + "static/media/dinamika-gradnje.f0d46c65.png";